import { Badge } from '@sgme/ui';
import type { StatusToColorMapper } from 'components/shared/Blotter/Grid/CellRenderers';
import { FormattedMessage } from 'components/shared/Intl';
import { FC, useMemo } from 'react';

export interface BlotterPanelStatusFieldProps {
  value: string;
  productSubType?: string;
}

export const BlotterPanelStatusField: FC<BlotterPanelStatusFieldProps> = ({ value, productSubType }) => {
  const color = useMemo(() => getStatusFieldColor(value) ?? 'primary', [value]);

  return (
    <Badge isPill color={color}>
      {!productSubType || productSubType === '' ? (
        value
      ) : (
        <FormattedMessage id={`blotterPanel.${productSubType}.status.${value}` as any} defaultMessage={value} />
      )}
    </Badge>
  );
};

BlotterPanelStatusField.displayName = 'BlotterPanelStatusField';

export const getStatusFieldColor: StatusToColorMapper<string> = status => {
  switch (status) {
    case 'Booked':
    case 'Merged':
    case 'Ordered':
    case 'Quoted':
    case 'Traded':
    case 'OK':
      return 'success';
    case 'Failed':
    case 'Rejected':
    case 'Timeout':
    case 'KO':
      return 'danger';
    case 'Pending':
    case 'Accepted':
    case 'Accepted - Booking In Progress':
    case 'Booking in progress':
    case 'Executed':
    case 'Exemption Pending':
    case 'Running':
    case 'TechnicalFailure':
    case 'Waiting':
    case 'Temporary Booked':
    case 'Accepted for booking':
      return 'warning';
    case 'Destroyed':
    case 'Locked':
    case 'Cancelled':
      return 'secondary';
    case 'Acknowledged':
      return 'info';
    default:
      return undefined;
  }
};
